import { processImageSEO } from './image'

export const processSEO = (seo: PageSEOSource): SEO => ({
  ...seo,
  description: seo.description.description,
  image: processImageSEO(seo.image),
})
